import React from 'react';
import {
  Box,
  FormControl,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import { LEAD_HELPERS, LEAD_LABELS } from './leadFieldUtils';

/**
 * 표준 leadField 기반 선행값 입력 — 부자재 시험성과대비표와 동일 UX
 * classificationComponents가 있으면 등급/분류는 Select로 구조화
 */
const GTestLeadFields = ({
  hasStandard = false,
  leadKeys = [],
  leadData = {},
  onLeadChange,
  classificationParts = [],
  onClassificationPartChange,
  classificationOptions = [],
  disabled = false,
}) => {
  const displayKeys = [];
  leadKeys.forEach((key) => {
    if (key === 'ft_thick_class') {
      if (!leadKeys.includes('thickness') && !displayKeys.includes('thickness')) {
        displayKeys.push('thickness');
      }
      if (!leadKeys.includes('classification') && !displayKeys.includes('classification')) {
        displayKeys.push('classification');
      }
      return;
    }
    displayKeys.push(key);
  });

  const hasClassificationSelects = displayKeys.includes('classification')
    && classificationOptions.length > 0;

  if (!hasStandard) {
    return (
      <Typography variant="body2" color="text.secondary">
        표준을 선택하면 필요한 선행 입력란이 표시됩니다.
      </Typography>
    );
  }

  if (!displayKeys.length) {
    return (
      <Typography variant="body2" color="text.secondary">
        이 표준에 선행값이 없습니다. 바로 성적서를 분석할 수 있습니다.
      </Typography>
    );
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
      {displayKeys.map((key) => {
        if (key === 'classification' && hasClassificationSelects) {
          return (
            <Box
              key={key}
              sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center' }}
            >
              {classificationOptions.map((opts, colIdx) => (
                <FormControl key={colIdx} size="small" sx={{ minWidth: 120 }} disabled={disabled}>
                  <Select
                    displayEmpty
                    value={classificationParts[colIdx] || ''}
                    onChange={(e) => onClassificationPartChange?.(colIdx, e.target.value)}
                    renderValue={(selected) => {
                      if (!selected) {
                        return (
                          <Typography component="span" color="text.secondary" variant="body2">
                            {colIdx === 0 ? (LEAD_LABELS[key] || '등급/분류') : `분류 ${colIdx + 1}`}
                          </Typography>
                        );
                      }
                      return selected;
                    }}
                  >
                    <MenuItem value="">
                      <em>선택</em>
                    </MenuItem>
                    {opts.map((o) => (
                      <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              ))}
            </Box>
          );
        }
        if (key === 'classification') {
          return (
            <TextField
              key={key}
              size="small"
              placeholder={LEAD_LABELS[key] || key}
              value={leadData[key] ?? ''}
              onChange={(e) => onLeadChange?.(key, e.target.value)}
              sx={{ width: 160 }}
              disabled={disabled}
            />
          );
        }
        return (
          <TextField
            key={key}
            size="small"
            placeholder={LEAD_LABELS[key] || key}
            title={LEAD_HELPERS[key] || undefined}
            value={leadData[key] ?? ''}
            onChange={(e) => onLeadChange?.(key, e.target.value)}
            sx={{ width: 140 }}
            type={key === 'thickness' ? 'number' : 'text'}
            inputProps={key === 'thickness' ? { step: 'any' } : undefined}
            disabled={disabled}
          />
        );
      })}
    </Box>
  );
};

export default GTestLeadFields;
